import React, { ReactNode } from "react";
import { SidebarLayout } from "@tether-web-portal/components/sidebar/SidebarLayout";
import { useDeviceCatalog } from "@tether-web-portal/api/catalog/hooks";

interface AppLayoutProps {
  children: ReactNode;
  sideBar?: boolean;
}

const AppLayout = ({ children, sideBar = true }: AppLayoutProps) => {
  // Load the device-type catalog once for the authenticated app so device names + icons resolve from
  // the catalog everywhere (the hook mirrors the result into the module cache used by formatDeviceName).
  useDeviceCatalog();

  if (sideBar) {
    return <SidebarLayout>{children}</SidebarLayout>;
  }

  return <>{children}</>;
};

export default AppLayout;
